import React, { useEffect, useState } from 'react';
import './OverlaySection.scss';
import { useNavigate } from "react-router-dom";

const OverlaySection: React.FC = () => {
    const [isVisible, setIsVisible] = useState(false);
    const navigate = useNavigate();

    const handleFreeInquiryClick = () => {
      navigate("/contact"); // Redirect to the Contact page
    };

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.3 }
    );

    const section = document.querySelector('.overlay-section__content');
    if (section) {
      observer.observe(section);
    }

    return () => observer.disconnect();
  }, []);
  return (
    <div className="overlay-section">
      <div className={`overlay-section__content ${isVisible ? 'animate' : ''}`}>
        <h3>EXPERT: 8+ YEARS OF EXPERIENCE</h3>
        <h1>SEAMLESS CLOTHING MANUFACTURER</h1>
        <ul>
          <li>100% Inspected Goods To Your Hand</li>
          <li>3 Tracking Reports During the Production Process</li>
          <li>A Lower MOQ from a Standardized Large Factory</li>
        </ul>
        <button onClick={handleFreeInquiryClick} className="overlay-section__button">Free Inquiry</button>
      </div>
    </div>
  );
};

export default OverlaySection;
